import axios from "axios";

const baseURL =
  process.env.REACT_APP_API_BASE_URL || "https://alnabaatech.com.ly";

export const adminApi = axios.create({
  baseURL: `${baseURL.replace(/\/$/, "")}/api`,
  headers: {
    Accept: "application/json",
    "X-Requested-With": "XMLHttpRequest",
  },
});

adminApi.interceptors.request.use((config) => {
  const token = localStorage.getItem("token");
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});
